// @owners { team: patients }
import { useQuery } from '@tanstack/react-query';
import getIsAuthorized from '~shared/features/auth/selectors/getIsAuthorized';
import { rateShipment } from '~shared/queries/query-keys/rateShipment';
import { useSelectorShared } from '~shared/store';

/**
 * Fetch the pending "rate shipment" survey via React Query — the strategy-A replacement for reading
 * the Redux rateShipment.pendingRating slice (no bridge). Components read this hook directly; the
 * non-React call sites (native app-open middleware, web post-auth hook) use fetchPendingRateShipment
 * with the query client instead. Runs only when authorized.
 */
export const useGetPendingRateShipment = () => {
  const isAuthorized = useSelectorShared(getIsAuthorized);
  const { data, isLoading, isSuccess } = useQuery({
    ...rateShipment.pending,
    enabled: isAuthorized,
  });

  return { pendingRating: data ?? null, isLoading, isSuccess };
};
